import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnmutedAlert = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.55556 13.3537V11.7894C9.72222 11.4587 10.662 10.8228 11.375 9.88173C12.088 8.94061 12.4444 7.87232 12.4444 6.67685C12.4444 5.48137 12.088 4.41308 11.375 3.47196C10.662 2.53084 9.72222 1.89495 8.55556 1.56429V0C10.163 0.356098 11.4722 1.15414 12.4833 2.39413C13.4944 3.63411 14 5.06168 14 6.67685C14 8.29201 13.4944 9.71958 12.4833 10.9596C11.4722 12.1995 10.163 12.9976 8.55556 13.3537ZM0 8.98513V4.40672H3.11111L7 0.591378V12.8005L3.11111 8.98513H0ZM8.55556 9.74819V3.6055C9.16481 3.88529 9.6412 4.30498 9.98472 4.86456C10.3282 5.42414 10.5 6.0346 10.5 6.69592C10.5 7.34453 10.3282 7.94545 9.98472 8.49867C9.6412 9.05189 9.16481 9.4684 8.55556 9.74819ZM5.44444 4.29226L3.77222 5.93285H1.55556V7.45899H3.77222L5.44444 9.09959V4.29226Z",
		fill: "#1F3171"
	})
});
export default SvgUnmutedAlert;
